module.exports = __webpack_public_path__ + "static/media/delete-target-icon.10ddbe26.svg";